const SupplierSuggestionType = {
  SUPPLIER_SUGGESTION_LIST: 'SUPPLIER_SUGGESTION_LIST',
  COMPONENT_TYPE: 'COMPONENT_TYPE',
  COMPOSITION_COMPONENT: 'COMPOSITION_COMPONENT',
  UNITS: 'UNITS',
  BOM_COMPONENT: 'BOM_COMPONENT',
  SUPPLIER_DATA: 'SUPPLIER_DATA',
  BOM_TYPE: 'BOM_TYPE',
  TESTING_BOM_COMPONENT: 'TESTING_BOM_COMPONENT',
  COLOUR_WAYS: 'COLOUR_WAYS',
  TESTING_LIBRARIES: 'TESTING_LIBRARIES',
  TESTING_LIBRARIES_FORM_DATA: 'TESTING_LIBRARIES_FORM_DATA',
  SET_MEASUREMENT: 'SET_MEASUREMENT',
  SET_CARE_LABEL: 'SET_CARE_LABEL',
  PRODUCTREF: 'PRODUCTREF',
  UPDATE_MEASUREMENT: 'UPDATE_MEASUREMENT',
  DUPLICTAE_MODAL: 'DUPLICTAE_MODAL',
  BRANDS: 'BRANDS',
  CATEGORY1: 'CATEGORY1',
  CATEGORY2: 'CATEGORY2',
  SET_SUGGESTION_DETAILS: 'SET_SUGGESTION_DETAILS',
  SET_SUPP_DATA_TO_UPDATE: 'SET_SUPP_DATA_TO_UPDATE',
  PLACEMENT_DATA: 'PLACEMENT_DATA',
  FINISHED_OPTIONS: 'FINISHED_OPTIONS',
  ALL_BOM_SUB_COMPONENT_OPTIONS: 'ALL_BOM_SUB_COMPONENT_OPTIONS',
  CLEAR_BOM_SUPPLIER_SUGGESTION: 'CLEAR_BOM_SUPPLIER_SUGGESTION',
};

export default SupplierSuggestionType;
